export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

export const API_ENDPOINTS = {
  OCR: `${API_BASE_URL}${process.env.REACT_APP_OCR_ENDPOINT || '/ocr/upload'}`,
  DEEPSEEK: `${API_BASE_URL}${process.env.REACT_APP_DEEPSEEK_ENDPOINT || '/deepseek/single-prompt'}`,
  DOWNLOAD: `${API_BASE_URL}${process.env.REACT_APP_DOWNLOAD_ENDPOINT || '/ocr/download'}`,
  AUTH: {
    LOGIN: `${API_BASE_URL}${process.env.REACT_APP_AUTH_LOGIN_ENDPOINT || '/oauth2/authorization/google'}`,
    SUCCESS: `${API_BASE_URL}${process.env.REACT_APP_AUTH_SUCCESS_ENDPOINT || '/api/auth/success'}`,
  }
}; 